<template>
    <div>
    <!-- 修改测试手机号弹窗 -->
    <el-dialog title="修改测试短信号码" append-to-body :visible="true" width="460px" :before-close="closeme" style="min-width: 1100px">
      <div class="dialog-wrapper">
        <!-- <div class="item" style="display: flex;justify-content: center;align-items: center;">
          <span class="item-title" style="width: 90px;">短信测试：</span>
          <el-input size="small" class="input" v-model="testMobiles"></el-input>
        </div> -->
        <div class="remarks">
          <div>请前往【京东云舟】-【工具】-【短信工具】-【短信签名】中进行修改号码中操作</div>
          <!-- <div>1、测试短信手机号不受频控限制，最多填写15个，多个之间用英文逗号分隔；</div>
          <div>2、修改完成后立即生效，且测试手机号的修改会应用到全部渠道；</div>
          <div>3、每天修改手机号的次数上限为5次；</div> -->
        </div>
        <div></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button style="width: 96px" @click="closeme">取消</el-button>
        <el-button @click="mobilPhoneSubmit" type="primary" style="width: 96px">提交</el-button> -->
        <el-button style="width: 96px" @click="closeme">关闭</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>
import { updateSuffixMobileById } from "@/api/backstage/messageBill";
export default {
    name:'changetestphone',
    props: {
        nowtestMobiles:{
            type: String,
            default: ''
        },
        textPhoneId:{
            type: String,
            default: ''
        }
    },
    components: {

    },
    data() {
        return {
            testMobiles:'',
        };
    },

    created() {
        this.testMobiles = this.nowtestMobiles
    },

    methods: {
        mobilPhoneSubmit(){
            updateSuffixMobileById({
                smsTestMobiles: this.testMobiles,
                id: this.textPhoneId,
            }).then(res=>{
                if(res.code == 1){
                    this.$message.success('更新成功')
                    this.$emit("mobilPhoneSubmit",this.testMobiles)
                }else{
                    this.$message.error(res)
                }
            })
        },
        closeme(){
            this.$emit("close")
        },
    },


};
</script>
<style lang='scss' scoped>
    .remarks {
    // margin-top: 20px;
    width: 400px;
    // height: 44px;
    background: #fafafa;
    opacity: 1;
    // line-height: 44px;
    line-height: 20px;
    padding: 12px 10px 10px 24px;
    font-size: 13px;
    position: relative;
    .img {
    display: inline-block;
    position: absolute;
    left: 8px;
    top: 15px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    }

    span {
      display: inline-block;
      margin-left: 25px;
      line-height: 20px;
    }
  }
  </style>
  